import styled from "styled-components";

export const HomeWrapper = styled.div`
  .slick-arrow {
    background-color: #eae7e7;
    margin-top: 0px;
    width: 52px;
    height: 120px;
  }
  
  
  .slick-list{
    margin-left: 30px;
  }
`;
